@import (reference) '../../../../constants/spacing.module.less';
@import (reference) '../style.module.less';

@button-minwidth: 140px;

.page-wrapper {
  &:extend(.settings-section all);
  max-width: 1440px;
}

.main-header {
  border-bottom: none;
}

.info-panel {
  display: flex;
}

.info-panel-description {
  margin: 0 @space-48 @space-8 0;
  line-height: @space-24;
}

.external-link-icon {
  width: 12px;
  margin-left: @space-4;
}

.logo {
  width: 270px;
}

.external-link {
  font-size: 14px;
  line-height: @space-24;
  margin-left: @space-4;
}

.key-generation-section {
  margin-top: @space-12;
}

.install-button {
  display: inline-flex;
  font-size: 12px;
  min-width: @button-minwidth;
  margin-top: @space-16;

  border: 1px solid var(--pine-green-border);
  border-radius: 4px;
  background: var(--pine-green);

  box-shadow: 0 1px 1px 0 rgba(33, 44, 54, 0.35);

  &:focus {
    background: var(--pine-green);
  }
  &:hover {
    background: var(--pine-green);
    border-color: var(--pine-green-border);
  }
}

.bolt-icon {
  width: 7px;
  margin: 0 @space-8;
  transform: rotate(30deg);
  fill: hsl(var(--gold-400-base)) !important;
}

.subheading {
  margin: 0;
  color: hsl(var(--grey-1000-base));
  font-size: 16px;
  font-weight: 500;
  line-height: @space-24;
}

.response-subheading {
  &:extend(.subheading);
  margin-top: @space-16;
}

.key-generation-subheading {
  &:extend(.subheading);
  margin-top: @space-24;
}

.banner-error {
  margin-top: @space-16;
}

.key-content {
  display: flex;
  align-items: center;
  margin-top: @space-4;
}

.response {
  color: hsl(var(--grey-800-base));
  font-size: 16px;
  line-height: @space-24;
  margin: 0 @space-8 0 0;
}

.copy-icon {
  width: 16px;
  cursor: pointer;
}

.generate-key-button {
  min-width: @button-minwidth;
  margin-top: @space-16;
}
